document.addEventListener('DOMContentLoaded', () => {
  const couponInput = document.querySelector('.cart-coupon__input');
  const couponLeft = document.querySelector('.cart-coupon__left');
  if (!couponInput || !couponLeft) return;

  couponInput.addEventListener('input', () => {
    couponLeft.classList.remove('cart-coupon__left--success', 'cart-coupon__left--error');
  });
});

document.addEventListener('click', async function (e) {
  const minus = e.target.closest('.cart-qty__minus');
  const plus = e.target.closest('.cart-qty__plus');

  if (!minus && !plus) return;

  e.preventDefault();

  const qtyBox = e.target.closest('.cart-qty');
  const input = qtyBox.querySelector('.cart-qty__input');
  const row = e.target.closest('.js-cart-row');

  if (!input || !row) return;

  let value = parseInt(input.value || 0, 10);

  if (minus) value = Math.max(0, value - 1);
  if (plus) value = value + 1;

  input.value = value;

  await updateCartRow(row.dataset.key, value, row);
});

async function updateCartRow(cartItemKey, quantity, row) {
  if (!themeVars?.ajax_url || !themeVars?.ajax_nonce) return;

  row.classList.add('is-loading');

  const formData = new FormData();
  formData.append('action', 'update_custom_cart_qty');
  formData.append('nonce', themeVars.ajax_nonce);
  formData.append('cart_item_key', cartItemKey);
  formData.append('quantity', quantity);

  try {
    const response = await fetch(themeVars.ajax_url, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
    });

    const result = await response.json();

    if (!result.success) {
      row.classList.remove('is-loading');
      return;
    }

    const data = result.data;

    if (data.removed) {
      row.remove();
    } else {
      const subtotalEl = row.querySelector('.js-line-subtotal');
      const priceEl = row.querySelector('.js-line-price');
      const inputEl = row.querySelector('.cart-qty__input');

      if (subtotalEl) subtotalEl.innerHTML = data.line_subtotal;
      if (priceEl) priceEl.innerHTML = data.line_price;
      if (inputEl) inputEl.value = data.quantity;
    }

    const cartTotal = document.querySelector('.js-cart-total');
    const cartSubtotal = document.querySelector('.js-cart-subtotal');

    if (cartTotal) cartTotal.innerHTML = data.cart_total;
    if (cartSubtotal) cartSubtotal.innerHTML = data.cart_subtotal;

  } catch (error) {
    console.error(error);
  } finally {
    row.classList.remove('is-loading');
  }
}
